import { render } from "./MerchDetailView.vue?vue&type=template&id=dc39c0fc&scoped=true&ts=true"
import script from "./MerchDetailView.vue?vue&type=script&lang=ts"
export * from "./MerchDetailView.vue?vue&type=script&lang=ts"

import "./MerchDetailView.vue?vue&type=style&index=0&id=dc39c0fc&lang=scss&scoped=true"

import exportComponent from "/Users/davidebertuzzi/WebstormProjects/procremonafrontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc39c0fc"]])

export default __exports__